import { BaseType } from '../base/base-type';

export class TransactionEntryLegacyCodeType extends BaseType {}
